function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useMemo } from 'react';
import { SkeletonElement, DefaultWrapper } from './elements';
export const Skeleton = /*#__PURE__*/forwardRef(({
  wrapper: Wrapper = DefaultWrapper,
  height,
  width = 'auto',
  elementCount = 1,
  duration = 1500,
  circle = false,
  ...rest
}, fRef) => {
  const elements = useMemo(() => Array(elementCount).fill(null).map((_, index) => index), [elementCount]);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    "data-aui": "skeleton"
  }, rest, {
    ref: fRef
  }), elements.map(key => /*#__PURE__*/React.createElement(SkeletonElement, {
    $duration: duration,
    $height: height,
    $width: width,
    $circle: circle,
    key: key,
    "aria-busy": "true",
    role: "status"
  })));
});